var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"forbidden",attrs:{"heading":"ERROR","sub-heading":"本機能をご利用いただく権限がございません"},scopedSlots:_vm._u([{key:"symbolMark",fn:function(){return [_c('div',{staticClass:"forbidden__symbolMark",style:({
        backgroundImage: ("url(" + (require('@/assets/images/Pages/Error/Forbidden/symbolMark.svg')) + ")")
      })})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }